import branchesIcon from '@jetbrains/icons/branches.svg'
import {Directions} from '@jetbrains/ring-ui/components/popup/popup.consts'
import Select from '@jetbrains/ring-ui/components/select/select'

import type {PipelineRepositoryBranchAutocompleteProps} from './PipelineRepositoryBranchAutocomplete.types'
import usePipelineRepositoryBranchAutocomplete from './usePipelineRepositoryBranchAutocomplete'

import styles from './PipelineRepositoryBranchAutocomplete.css'

function PipelineRepositoryBranchAutocomplete({
  options,
  onChange,
  value,
}: PipelineRepositoryBranchAutocompleteProps) {
  const {searchValue, errorMessage, onChangeSelect, selectBlurHandler, branchAutocompleteOptions} =
    usePipelineRepositoryBranchAutocomplete(options, onChange, value)

  return (
    <Select
      error={errorMessage}
      className={styles.select}
      type={Select.Type.INPUT}
      selected={value}
      directions={[Directions.BOTTOM_LEFT]}
      inputPlaceholder={'Default branch'}
      filter={{value: searchValue, fn: () => true}}
      filterIcon={branchesIcon}
      data={branchAutocompleteOptions}
      notFoundMessage={''}
      label={'Default branch'}
      onChange={onChangeSelect}
      onBlur={selectBlurHandler}
      allowAny
      clear
    />
  )
}

export default PipelineRepositoryBranchAutocomplete
